import { Expense } from '../../types/expenses';
import { format } from 'date-fns';
import { DollarSign } from 'lucide-react';
import { useLanguageStore } from '../../store/languageStore';
import translations from '../../translations';

interface RecentExpensesProps {
  expenses: Expense[];
}

export function RecentExpenses({ expenses }: RecentExpensesProps) {
  const { language } = useLanguageStore();
  const t = translations[language];

  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  return (
    <div className="bg-light-card dark:bg-dark-card rounded-lg p-6 border border-light-border dark:border-dark-border shadow-soft dark:shadow-soft-dark">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">{t.dashboard.recentActivity.expenses.title}</h2>
      
      {expenses.length === 0 ? (
        <p className="text-sm text-gray-500 dark:text-gray-400">{t.dashboard.recentActivity.expenses.noExpenses}</p>
      ) : (
        <div className="space-y-3">
          {expenses.map(expense => (
            <div 
              key={expense.id}
              className="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-900/20"
            >
              <div className="bg-primary-50 dark:bg-primary-900/20 rounded-lg p-2">
                <DollarSign className="h-4 w-4 text-primary-600 dark:text-primary-400" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex justify-between items-start gap-2">
                  <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                    {formatAmount(expense.amount)}
                  </p>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    {format(new Date(expense.createdAt), 'MMM d, h:mm a')}
                  </span>
                </div>
                <p className="text-sm text-gray-600 dark:text-gray-400 truncate">
                  {expense.comment}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}